import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';
import { Route, Routes } from 'react-router-dom';

import { AccountProvider } from './AccountProvider';
import { useCustomer } from './CustomerProvider';
import DirectDeposit from './DirectDeposit';
import NotFound from './NotFound';
import Summary from './Summary';
import Transactions from './Transactions';
import TransactionsExport from './TransactionsExport';

import CheckingDepositFlow from '../../CheckingDepositFlow';
import FundingOptions from '../../CheckingFundingOptions';
import CheckingWithdrawalFlow from '../../CheckingWithdrawalFlow';
import { WithLayout } from '../../RetailApp/components/WithLayout';

const AccountRouter: React.FC = () => {
  const accountId = useRequiredParam('accountId');
  const { customer } = useCustomer();
  const account = customer.accounts.find(({ id }) => id === parseInt(accountId || '', 10));

  if (!account) {
    return (
      <WithLayout parts={{ sidebar: true, footer: true }}>
        <NotFound />
      </WithLayout>
    );
  }

  return (
    <AccountProvider account={account}>
      <Routes>
        <Route
          data-feature="checking_account_summary"
          index={true}
          element={
            <WithLayout parts={{ sidebar: true, footer: true }} feature="checking_account_summary">
              <Summary />
            </WithLayout>
          }
        />
        <Route
          data-feature="checking_account_transactions"
          path="/transactions"
          element={
            <WithLayout parts={{ sidebar: true, footer: true }} feature="checking_account_transactions">
              <Transactions />
            </WithLayout>
          }
        />
        <Route
          data-feature="checking_account_funding_options"
          path="/funding_options"
          element={
            <WithLayout parts={{ sidebar: false, footer: true }} feature="checking_account_funding_options">
              <FundingOptions />
            </WithLayout>
          }
        />
        <Route
          data-feature="checking_account_direct_deposit"
          path="/direct_deposit/*"
          element={
            <WithLayout parts={{ sidebar: false, footer: true }} feature="checking_account_direct_deposit">
              <DirectDeposit />
            </WithLayout>
          }
        />
        <Route
          data-feature="checking_account_withdrawal_flow"
          path="/withdrawal_setup/*"
          element={
            <WithLayout parts={{ sidebar: false, footer: true }} feature="checking_account_withdrawal_flow">
              <CheckingWithdrawalFlow />
            </WithLayout>
          }
        />
        <Route
          data-feature="checking_account_deposit_flow"
          path="/deposit_setup/*"
          element={
            <WithLayout parts={{ sidebar: false, footer: true }} feature="checking_account_deposit_flow">
              <CheckingDepositFlow />
            </WithLayout>
          }
        />

        <Route
          data-feature="checking_account_transactions_export"
          path="/transactions_export"
          element={
            <WithLayout parts={{ sidebar: false, footer: true }} feature="checking_account_transactions_export">
              <TransactionsExport />
            </WithLayout>
          }
        />
      </Routes>
    </AccountProvider>
  );
};

export default AccountRouter;
